import { Injectable, Component } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class FilterSubMenuService {
  private setfilterSubMenu$ = new Subject<string>();
  getFilterSubMenu$: Observable<string> = this.setfilterSubMenu$.asObservable();

  setFilterSubMenu(subMenu: string): void {
    this.setfilterSubMenu$.next(subMenu);
  }
}
